export default __webpack_public_path__ + "static/media/imgCovid.d1b377e7.png";